export const APP_CONST = Object.freeze({
  AUTH_ACTIONS: {
    LOGIN: "login",
    REGISTER: "register",
  },
  TOAST_TYPE: {
    ERROR: "error",
    SUCCESS: "success",
    INFO: "info",
    WARNING: "warning",
  },
  SPORTS_ID: {
    CIRCKET: "4",
    SOCCER: "1",
    TENNIS: "2",
  },
  ALL_MARKET_IDS: {
    CRICKET: "CRICKET_IDS",
    SOCCER: "SOCCER_IDS",
    TENNIS: "TENNIS_IDS",
  },
  ODDS_TYPE: {
    BACK: "back",
    LAY: "lay",
  },
  TEST: {},
  PLAYER_BANK_DETAILS_TYPE: {
    Bank: "bank",
    Card: "card",
  },
  ORGANISATION_STATUS: {
    Maintenance: "maintenance",
    Live: "live",
    Suspended: "suspended",
  },
  ENVIRONMENTS: {
    PRODUCTION: "production",
    DEVELOPMENT: "development",
  },
});

export const APK_LS_KEY = "knhf65sd";
export const UPDATE_PASSWORD_FLAG_KEY = "psdupdt";

export const PASSWORD_UPDATE_TYPE = {
  type0: "t0",
  type1: "t1",
};

export const GTW_MODE = {
  Deposit: "deposit",
  Withdraw: "withdraw",
};

export const BankModeRequiredFields = [
  "accountNo",
  "accountName",
  "iban",
  "ifscCode",
  "bankName",
];

export const SHOW_COPY_BUTTON = true;

export const AuthModals = Object.freeze({
  Login: "login",
  Register: "register",
  MobileNumber: "mobileNumber",
  VerifyNumber: "verifyNumber",
  ForgotPassword: "forgotPassword",
  ResetPassword: "resetPassword",
});

export const IsAuthModalView = true;
